if (!customElements.get('upsell-toggle')) {
  customElements.define(
    'upsell-toggle',
    class UpsellToggle extends HTMLElement {
      constructor() {
        super();

        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.row = this.querySelector('.upsell-toggle__row');

        this.variantId = this.dataset.variantId;
        this.available = this.dataset.available === 'true';

        // Always start unchecked — toggle is intent-only, fresh on every page load
        if (this.checkbox) {
          this.checkbox.checked = false;
          if (!this.available) {
            this.checkbox.disabled = true;
          }
          this.checkbox.addEventListener('change', this.onToggleChange.bind(this));
        }
      }

      onToggleChange() {
        // Just toggle the visual state, no AJAX
        if (this.row) {
          this.row.classList.toggle('upsell-toggle__row--active', this.checkbox.checked);
        }
      }

      isChecked() {
        return this.checkbox && this.checkbox.checked && !this.checkbox.disabled;
      }

      reset() {
        if (this.checkbox) this.checkbox.checked = false;
        if (this.row) this.row.classList.remove('upsell-toggle__row--active');
      }
    }
  );
}

/* ----------------------------------------------------------------------
 * Intercept the main product form submit to:
 *  - add upsells together with the main product in a single /cart/add
 *  - apply a volume-discount discount code via redirect to /discount/CODE
 * ---------------------------------------------------------------------- */
(function () {
  function getCheckedUpsells() {
    const toggles = document.querySelectorAll('upsell-toggle');
    return Array.from(toggles).filter(
      (t) => t.checkbox && t.checkbox.checked && !t.checkbox.disabled
    );
  }

  function getActiveDiscountCode() {
    const vd = document.querySelector('volume-discount');
    if (!vd) return '';
    return vd.dataset.activeDiscountCode || '';
  }

  function setupInterceptor() {
    const forms = document.querySelectorAll('product-form form');

    forms.forEach((form) => {
      if (form.dataset.upsellInterceptorBound === 'true') return;
      form.dataset.upsellInterceptorBound = 'true';

      form.addEventListener(
        'submit',
        function (evt) {
          const checkedUpsells = getCheckedUpsells();
          const discountCode = getActiveDiscountCode();

          // If neither upsells nor a discount code are active, let
          // product-form handle the submit normally.
          if (checkedUpsells.length === 0 && !discountCode) return;

          // Take over the submission
          evt.preventDefault();
          evt.stopImmediatePropagation();

          const productFormElement = form.closest('product-form');
          const submitButton = form.querySelector('[type="submit"]');
          const spinner = form.querySelector('.loading__spinner');
          const cart =
            document.querySelector('cart-notification') ||
            document.querySelector('cart-drawer');

          if (productFormElement && productFormElement.handleErrorMessage) {
            productFormElement.handleErrorMessage();
          }

          if (submitButton) {
            submitButton.setAttribute('aria-disabled', 'true');
            submitButton.classList.add('loading');
          }
          if (spinner) spinner.classList.remove('hidden');

          // Build items array: main product first, then each checked upsell
          const formData = new FormData(form);
          const mainVariantId = formData.get('id');
          const mainQuantity = parseInt(formData.get('quantity') || '1', 10);

          const items = [{ id: mainVariantId, quantity: mainQuantity || 1 }];
          checkedUpsells.forEach((toggle) => {
            items.push({ id: toggle.variantId, quantity: 1 });
          });

          const sections =
            cart && cart.getSectionsToRender
              ? cart.getSectionsToRender().map((s) => s.id)
              : [];

          if (cart && cart.setActiveElement) {
            cart.setActiveElement(document.activeElement);
          }

          const body = JSON.stringify({
            items: items,
            sections: sections,
            sections_url: window.location.pathname,
          });

          fetch(`${routes.cart_add_url}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: body,
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                if (productFormElement && productFormElement.handleErrorMessage) {
                  productFormElement.handleErrorMessage(
                    response.description || response.message
                  );
                }
                console.error(
                  'Cart add error:',
                  response.description || response.message
                );
                return;
              }

              // Reset all upsell toggles after successful add
              checkedUpsells.forEach((toggle) => {
                if (toggle.reset) toggle.reset();
              });

              // If a discount code is active, redirect to /discount/CODE
              // which applies the code and lands the user back on /cart.
              if (discountCode) {
                const target =
                  '/discount/' +
                  encodeURIComponent(discountCode) +
                  '?redirect=' +
                  encodeURIComponent('/cart');
                window.location.href = target;
                return;
              }

              // No discount code: open cart drawer/notification as usual
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: mainVariantId,
                cartData: response,
              });

              if (cart && cart.renderContents) {
                cart.renderContents(response);
              } else if (!cart) {
                window.location = window.routes.cart_url;
              }
            })
            .catch((e) => {
              console.error('Cart add failed:', e);
            })
            .finally(() => {
              if (!discountCode) {
                if (submitButton) {
                  submitButton.classList.remove('loading');
                  submitButton.removeAttribute('aria-disabled');
                }
                if (spinner) spinner.classList.add('hidden');
                if (cart && cart.classList.contains('is-empty')) {
                  cart.classList.remove('is-empty');
                }
              }
            });
        },
        true // capture phase
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupInterceptor);
  } else {
    setupInterceptor();
  }

  // Re-bind on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', setupInterceptor);
})();
